import { type ReactNode } from 'react';
import { AuthProvider } from '@/shared/state/auth-context';

export function Providers({ children }: { children: ReactNode }) {
  return <AuthProvider>{children}</AuthProvider>;
}
